import React from "react";
import { FaExclamationCircle } from "react-icons/fa";

import { IconTag } from "./IconTag";

type FailedTagProps = {
  text?: string;
};

/**
 * An IconTag wrapper to mark something as "failed".
 */
function IconTagFailed({ text = "Failed", ...delegated }: FailedTagProps) {
  return (
    <IconTag
      icon={FaExclamationCircle}
      text={text}
      colorScheme="danger"
      {...delegated}
    />
  );
}

export { IconTagFailed };
